import { Button, Result } from "antd";
import { useDispatch } from "react-redux";
import { useTrackingOp } from "../../../../contexts/TrackingOpContext";
import { loginActions } from "../../../../pages/LoginPage/reducer";
import { OP_STATUS } from "../../../../util/varibles/constants";
import { IService2 } from "../../../../util/varibles/interface";
import Icon, { ICON_NAME } from "../../../Icon";
import Header from "../../_components/Header";
import ServiceSteps from "../../_components/ServiceSteps";
import PauseCount from "../../_components/Pause/PauseCount";
import PauseButton from "../../_components/Pause/PauseButton";
import NextStep from "../../_components/StepControl/NextStep";
import stylesOp from "../style.module.scss";

const Views: { [id: string]: React.FC<{ data: IService2 }> } = {
    [OP_STATUS.APPROVED]: () => {
        return <div className='flex justify-center mt-5'>
            <NextStep name='start operation'>
                Start operation
            </NextStep>
        </div>
    },
    [OP_STATUS.PROCESSING]: () => {
        return <ServiceSteps />
    },
    [OP_STATUS.FINISHED]: () => {
        const dispatch = useDispatch();
        return <Result
            status="success"
            title={<div className='font-s16 font-w4'>Operation is completed</div>}
            extra={<div className='flex justify-content-center'>
                <Button className='bt-primary' onClick={() => dispatch(loginActions.getOpsOfVessel())}>
                    Continue
                </Button>
            </div>}
        />
    }
}

export default function Service() {
    const [op] = useTrackingOp(state => state.op?.operation as IService2);

    if (!op) return null;

    const { status, site, sub_operations } = op;
    const { name: siteName = "" } = site || {}
    const { [status || ""]: View } = Views;

    return <div className="flex flex-col h-full">
        <Header
            icon={<Icon icon={ICON_NAME.SERVICE} />}
            extand={<div className="ml-auto flex justify-between w-min">
                <div className="absolute left-[50%]">
                    <PauseCount />
                </div>
                <div className=" mr-[15px]">
                    <PauseButton data={op} />
                </div> 
            </div>}
        >
            <div className={[stylesOp['operation-route'], 'flex items-center'].join(' ')}>
                <span>{[siteName, sub_operations.map((item: any) => item.unit_id).join(', ')].join(' - ')}</span>
            </div>
        </Header>
        <div className="flex-1 overflow-y-auto ml-[-20px] w-[calc(100% + 40px)] relative">
            {View && <View data={op} />}
        </div>
    </div>
}